import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["applyPromo", "promoRow", "promoInput", "discountId", "attachmentsBlock", "noteInput", "fileInput"]

    connect() {
        this.togglePromoRow()
        this.updateAttachmentVisibility()
    }

    togglePromoRow() {
        if (!this.hasPromoRowTarget || !this.hasApplyPromoTarget) return
        const show = this.applyPromoTarget.checked
        this.promoRowTarget.classList.toggle("hidden", !show)
    }

    onApplyPromoChange() {
        this.togglePromoRow()
        this.requestPriceRefresh()
    }

    onPromoInput() {
        if (this.hasPromoInputTarget && this.promoInputTarget.value) {
            this.promoInputTarget.value = this.promoInputTarget.value.trim().toUpperCase()
        }
        this.requestPriceRefresh()
    }

    onDiscountChange() {
        this.updateAttachmentVisibility()
        this.requestPriceRefresh()
    }

    updateAttachmentVisibility() {
        if (!this.hasAttachmentsBlockTarget) return
        // If any discount_id is selected, show attachments/note block
        const selected = this.discountIdTargets.some(rb => rb.checked)
        this.attachmentsBlockTarget.classList.toggle("hidden", !selected)
        if (this.hasFileInputTarget) this.fileInputTarget.disabled = !selected
    }

    requestPriceRefresh() {
        // bubble to the form controller
        this.dispatch("refresh", {bubbles: true})
    }
}
